import "../css/documentation.css";
const Documentation = () => {
  const onButtonClick = () => {
    // using Java Script method to get PDF file
    fetch("pdf/research_report_tom_creighton_k00253257.pdf").then(
      (response) => {
        response.blob().then((blob) => {
          // Creating new object of PDF file
          const fileURL = window.URL.createObjectURL(blob);
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = "pdf/research_report_tom_creighton_k00253257.pdf";
          alink.click();
        });
      }
    );
  };
  return (
    <main>
      <div id="info">
        <div id="info_header" data-aos="fade-up">
          <h1>Documentation</h1>
          <div id="doc_rect"></div>
        </div>
        <div class="info_row" data-aos="fade-up">
          <div class="info_block_right teal">
            <h3>
              Research <br /> Report
            </h3>
            <p>
              CheatSheet was Design to be both pretty and accessible. Download
              the CheatSheet style guide to see how this was achieved.
            </p>
            <div class="doc_button">
              <button class="download_btn" onClick={onButtonClick}>
                Download
              </button>
            </div>
          </div>
          <div class="info_block_left pink">
            <h3>
              Style <br /> Guide
            </h3>
            <p>
              CheatSheet was Design to be both pretty and accessible. Download
              the CheatSheet style guide to see how this was achieved.
            </p>
            <div class="doc_button">
              <a class="download_btn disabled_button" href="#">
                Download
              </a>
            </div>
          </div>
          <div class="info_block_right blue">
            <h3>
              Github <br /> Repository
            </h3>
            <p>
              If you are interested in seeing under the hood, why not pop over
              to the CheatSheet GitHub Repository.
            </p>
            <div class="doc_button">
              <a
                class="download_btn"
                href="https://github.com/tomcreigh/CheatSheet"
              >
                Github
              </a>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Documentation;
